/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type SocialAnamnesisDtoImmunosuppressionStatus =
  | (typeof SocialAnamnesisDtoImmunosuppressionStatus)[keyof typeof SocialAnamnesisDtoImmunosuppressionStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocialAnamnesisDtoImmunosuppressionStatus = {
  UNKNOWN: 'UNKNOWN',
  IMMUNOSUPPRESSED: 'IMMUNOSUPPRESSED',
  NOT_IMMUNOSUPPRESSED: 'NOT_IMMUNOSUPPRESSED',
} as const;
